// extracted by mini-css-extract-plugin
export var option = "_53-1";
export var optionActive = "_53-2";
export var pill = "_53-0";